import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "create-form" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { for: "i_type" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { for: "i_invoiceType" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { for: "i_serviceId" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { for: "i_name" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { for: "i_start" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { for: "i_end" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { for: "i_number" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { for: "i_person" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { for: "i_manager" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 5 }

import { ProjectItem } from "@/services/entities/ProjectItem";
import { useOverviewStore } from "@/stores/overview";
import { onMounted, reactive } from "vue";
import VueSelect from "vue-select";
import { useSettingsStore } from "@/stores/setting";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectForm',
  props: {
  title: String,
  value: { Type: {} as ProjectItem, default: {} as ProjectItem },
  edit: { Type: Boolean, default: false },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {


const emit = __emit;
const overviewStore = useOverviewStore();
const settingsStore = useSettingsStore();

const props = __props;

onMounted(async () => {
  await settingsStore.loadServices();
});

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "header"),
    _createElementVNode("div", _hoisted_1, [
      (!props.edit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, [
              _cache[13] || (_cache[13] = _createTextVNode("Project type", -1)),
              (!props.value.projectTypeId)
                ? (_openBlock(), _createElementBlock("b", _hoisted_4, "*"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(VueSelect), {
              label: "name",
              modelValue: props.value.projectTypeId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.value.projectTypeId) = $event)),
              options: _unref(overviewStore).getProjectTypes,
              appendToBody: true,
              clearable: false,
              reduce: (item) => item.id
            }, null, 8, ["modelValue", "options", "reduce"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.$props.value?.projectTypeId == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _cache[14] || (_cache[14] = _createTextVNode("Invoice type", -1)),
              (!props.value.invoiceTypeId)
                ? (_openBlock(), _createElementBlock("b", _hoisted_7, "*"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(VueSelect), {
              label: "name",
              options: _unref(overviewStore).getInvoiceType,
              clearable: false,
              reduce: (item) => item.id,
              appendToBody: true,
              modelValue: props.value.invoiceTypeId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((props.value.invoiceTypeId) = $event))
            }, null, 8, ["options", "reduce", "modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.$props.value?.projectTypeId == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, [
              _cache[15] || (_cache[15] = _createTextVNode("Service", -1)),
              (!props.value.serviceId)
                ? (_openBlock(), _createElementBlock("b", _hoisted_10, "*"))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(VueSelect), {
              label: "blServiceName",
              options: _unref(settingsStore).getServices.filter(s => s.isActive),
              clearable: false,
              appendToBody: true,
              reduce: (item) => item.id,
              modelValue: props.value.serviceId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.value.serviceId) = $event))
            }, null, 8, ["options", "reduce", "modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_11, [
          _cache[16] || (_cache[16] = _createTextVNode("Project name", -1)),
          (!props.value.projectName)
            ? (_openBlock(), _createElementBlock("b", _hoisted_12, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_name",
          type: "string",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((props.value.projectName) = $event))
        }, null, 512), [
          [_vModelText, props.value.projectName]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_13, [
          _cache[17] || (_cache[17] = _createTextVNode("Project start", -1)),
          (!props.value.projectStartPicker)
            ? (_openBlock(), _createElementBlock("b", _hoisted_14, "*"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_VueDatePicker, {
          teleport: true,
          "enable-time-picker": false,
          "month-picker": "",
          modelValue: props.value.projectStartPicker,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((props.value.projectStartPicker) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_15, [
          _cache[18] || (_cache[18] = _createTextVNode("Project end", -1)),
          (!props.value.projectEndPicker)
            ? (_openBlock(), _createElementBlock("b", _hoisted_16, "*"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_VueDatePicker, {
          teleport: true,
          "enable-time-picker": false,
          "month-picker": "",
          modelValue: props.value.projectEndPicker,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((props.value.projectEndPicker) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_17, [
          _cache[19] || (_cache[19] = _createTextVNode("Project number", -1)),
          (!props.value.projectNumber)
            ? (_openBlock(), _createElementBlock("b", _hoisted_18, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_number",
          type: "string",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((props.value.projectNumber) = $event))
        }, null, 512), [
          [_vModelText, props.value.projectNumber]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_19, [
          _cache[20] || (_cache[20] = _createTextVNode("Responsible person", -1)),
          (!props.value.responsiblePerson)
            ? (_openBlock(), _createElementBlock("b", _hoisted_20, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_person",
          type: "string",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((props.value.responsiblePerson) = $event))
        }, null, 512), [
          [_vModelText, props.value.responsiblePerson]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_21, [
          _cache[21] || (_cache[21] = _createTextVNode("Project manager", -1)),
          (!props.value.projectManager)
            ? (_openBlock(), _createElementBlock("b", _hoisted_22, "*"))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "i_manager",
          type: "string",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((props.value.projectManager) = $event))
        }, null, 512), [
          [_vModelText, props.value.projectManager]
        ])
      ]),
      (_ctx.$props.value?.projectTypeId == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _cache[22] || (_cache[22] = _createElementVNode("label", null, "Use checkbox for day activity report", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.$props.value.isCheckbox) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.$props.value.isCheckbox]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.$props.value?.projectTypeId == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _cache[23] || (_cache[23] = _createElementVNode("label", null, "Use custom activity", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.$props.value.isCustomActivity) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.$props.value.isCustomActivity]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.$props.value?.projectTypeId == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _cache[24] || (_cache[24] = _createElementVNode("label", { for: "i_nonBillableProjectType" }, "Non-billable project type", -1)),
            _createVNode(_unref(VueSelect), {
              label: "name",
              modelValue: _ctx.$props.value.nonBillableProjectType,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.$props.value.nonBillableProjectType) = $event)),
              options: _unref(overviewStore).getNonBillableProjectType,
              appendToBody: true,
              clearable: false,
              reduce: (item) => item.id
            }, null, 8, ["modelValue", "options", "reduce"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _cache[25] || (_cache[25] = _createElementVNode("label", { for: "i_description" }, "Description", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "i_description",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((props.value.description) = $event))
        }, null, 512), [
          [_vModelText, props.value.description]
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "buttons")
  ], 64))
}
}

})